import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const StyledModalContent = styled(FlexColumn)`
    margin-top: -4px;
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
    gap: 16px;
    overflow: visible;
`;

export const StyledModalChipsSection = styled(FlexColumn)`
    width: 100%;
    min-width: 0;
    min-height: 40px;
    gap: 12px;
`;

export const StyledInputModeFrame = styled(FlexColumn)`
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
    gap: 16px;
    padding: 16px;
    border-radius: 6px;
    background-color: ${colorsPalettes.bluegrey[200]};
`;

export const StyledSegmentedControlContainer = styled(Flex)`
    width: 100%;
    min-width: 0;
`;

export const StyledBulkModeContainer = styled(FlexColumn)`
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
    gap: 16px;
`;

export const StyledCodesInputSection = styled.div`
    position: relative;
    flex: 1 1 0;
    min-width: 0;
    width: 100%;
    box-sizing: border-box;
    overflow: visible;
    z-index: 1;

    & > * {
        width: 100%;
        box-sizing: border-box;
    }
`;
